import React from 'react';
import GetAppTwoToneIcon from '@mui/icons-material/GetAppTwoTone';
import PopperMenuButton, { ButtonMenu } from '../popper-menu-button';

interface Props {
  metadata: Record<string, any>;
}
const MediaInteractions: React.FC<Props> = ({ metadata }) => {
  const downloadFile = (url: string) => {
    const link = document.createElement('a');
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.href = url;
    link.click();
  };

  const downloadInteraction: ButtonMenu = {
    icon: <GetAppTwoToneIcon />,
    toolTipCopy: 'Download media',
    items: [
      {
        copy: 'Original',
        callBack: () => {
          downloadFile(metadata.original);
        },
      },
      {
        copy: 'Large',
        callBack: () => {
          downloadFile(metadata.large);
        },
      },
      {
        copy: 'Thumbnail',
        callBack: () => {
          downloadFile(metadata.thumbnail);
        },
      },
    ],
  };

  return (
    <PopperMenuButton
      buttonMenu={downloadInteraction}
      onClose={() => null}
    />
  );
};

export default MediaInteractions;
